import axiosInstance from "../../config/axiosInstance";

const addUserOperationRequest = async user => {
  const response = await axiosInstance.dillApi().post("/admin/users", user);
  return response;
};

export default addUserOperationRequest;
